"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = void 0;
let Layout;
exports.Layout = Layout;
(function (Layout) {
  Layout["[band][row][column]"] = "[band][row][column]";
  Layout["[band][row,column]"] = "[band][row,column]";
  Layout["[band,row,column]"] = "[band,row,column]";
  Layout["[row,column,band]"] = "[row,column,band]";
  Layout["[row,column][band]"] = "[row,column][band]";
  Layout["[row][column][band]"] = "[row][column][band]";
  Layout["[row][column,band]"] = "[row][column,band]";
})(Layout || (exports.Layout = Layout = {}));